import {
  trackAdminPwaAnalytics,
  type AdminPwaAnalyticsPayload,
} from './AdminPwaAnalytics.js';

export type {
  AdminPwaAnalyticsEventName,
  AdminPwaAnalyticsPayload,
} from './AdminPwaAnalytics.js';

function dispatchDebugCustomEvent(payload: AdminPwaAnalyticsPayload): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent('rpapp-admin-pwa-analytics', {
      detail: {
        eventName: payload.eventName,
        screenName: payload.screenName ?? 'pwa_lifecycle',
        metadata: payload.metadata,
      },
    }),
  );
}

/**
 * Best-effort PWA lifecycle emit (L58). Typed to ANALYTICS_PWA_EVENTS — no casts.
 * Primary path: real ingest via trackAdminPwaAnalytics (sessions + events).
 * CustomEvent is secondary debug only — after track has been attempted.
 */
export function emitAdminPwaAnalytics(payload: AdminPwaAnalyticsPayload): void {
  void trackAdminPwaAnalytics(payload);
  dispatchDebugCustomEvent(payload);
}
